import fetchAPI from '../../fetchAPI';

interface callGetCoreOfficeAddressProps {
  locationId: string;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string | string[];
}

export const callGetCoreOfficeAddress = async (
  props: callGetCoreOfficeAddressProps
): Promise<iResponse<Pagination<CoreOfficeAddress>>> => {
  const { pageNumber, pageSize, sortBy, locationId } = props;

  const queryParams = new URLSearchParams();
  if (pageNumber) {
    queryParams.append('pageNumber', pageNumber.toString());
  }
  if (pageSize) {
    queryParams.append('pageSize', pageSize.toString());
  }
  if (sortBy) {
    if (Array.isArray(sortBy)) {
      sortBy.forEach((sort) => queryParams.append('sortBy', sort));
    } else {
      queryParams.append('sortBy', sortBy);
    }
  }


  const queryString = queryParams.toString();
  const response: iResponse<Pagination<CoreOfficeAddress>> = await fetchAPI({
    method: `GET`,
    route: `core/location/${locationId}/offices-address`,
    queryString
  });

  return response;
};

export default callGetCoreOfficeAddress;
